import React from "react";

type AgentBarRowProps = {
	name: string;
	right: React.ReactNode;
	className?: string;
};

const AgentBarRow: React.FC<AgentBarRowProps> = ({ name, right, className }) => {
	return (
		<div className={`flex items-center py-1.5 hover:bg-gray-50 dark:hover:bg-white/5 group rounded ${className || ''}`}>
			<div className="w-32 text-[11px] text-teamscx-primary dark:text-white pr-4 flex-shrink-0">
				<div className="truncate" title={name}>{name}</div>
			</div>
			<div className="flex-1">
				{right}
			</div>
		</div>
	);
};

export default AgentBarRow;


